import styled from 'styled-components';
import device from '../mediaQueries';

const Button = styled.button`
  border-radius: ${({ borderRadius }) => borderRadius || '5px'};;
  border: 0px;
  width: ${({ width }) => width || '100%'};
  max-width: ${({ maxWidth }) => maxWidth || '100%'};
  height: ${({ height }) => height || '44px'};
  color: ${({ color }) => color || '#FFF'};
  font-size: ${({ fontSize }) => fontSize || '15px'};
  font-family: 'Avenir Black', 'Arial Black', sans-serif;
  text-transform: ${({ textTransform }) => textTransform || 'uppercase'};
  letter-spacing: ${({ letterSpacing }) => letterSpacing || '1px'};
  padding-top: 3px;
  background-color: ${({ backgroundColor }) => backgroundColor || '#000'};
  ${({ margin }) => `margin: ${margin};` || null}
  disabled: ${({ disabled }) => disabled}

  ${device.mobile`
    ${({ mobileHeight, height }) => (mobileHeight || height) && `height: ${mobileHeight || height}`};
    ${({ mobileWidth, width }) => (mobileWidth || width) && `width: ${mobileWidth || width}`};
  `}

  ${device.desktop`
    ${({ desktopWidth, width }) => (desktopWidth || width) && `width: ${desktopWidth || width}`};
    ${({ desktopHeight, height }) => (desktopHeight || height) && `height: ${desktopHeight || height}`};
  `}

`;

export default Button;
